var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('report-base',{attrs:{"reports":_vm.listLinkDowloadCSV,"type":"general"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }